import { Brand, Type, Environment } from '.';
function getBaseURL(brand, type, environment, lendiGroupTeamView) {
    if (typeof window !== 'undefined') {
        switch (window.location.hostname) {
            case 'www.lendi.com.au.local':
            case 'team.lendi.com.au.local':
            case 'dlf.lendi-paas.net.local':
            case 'team.aussie.com.au.local':
                return location.origin;
        }
        if (window.location.hostname && window.location.hostname.indexOf('test.lendi-dev.net') >= 0) {
            return location.origin;
        }
    }
    if (brand === Brand.Lendi && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return !lendiGroupTeamView ? 'https://team.lendi-dev.net' : 'https://lendi-team-dev.lendigroup.com.au';
            case Environment.Staging:
                return !lendiGroupTeamView ? 'https://team.lendi-stg.net' : 'https://lendi-team-stg.lendigroup.com.au';
            case Environment.Preproduction:
                return !lendiGroupTeamView ? 'https://team.lendi-preprod.net' : 'https://lendi-team-preprod.lendigroup.com.au';
            case Environment.Production:
                return !lendiGroupTeamView ? 'https://team.lendi.com.au' : 'https://lendi-team.lendigroup.com.au';
        }
    }
    if (brand === Brand.Domain && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return 'https://team-dlf.lendi-dev.net';
            case Environment.Staging:
                return 'https://team-dlf.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://team-dlf.lendi-preprod.net';
            case Environment.Production:
                return 'https://team-dlf.lendi.com.au';
        }
    }
    if (brand === Brand.Aussie && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return !lendiGroupTeamView ? 'https://team.aussie-dev.com.au' : 'https://aussie-team-dev.lendigroup.com.au';
            case Environment.Staging:
                return !lendiGroupTeamView ? 'https://team.aussie-stg.com.au' : 'https://aussie-team-stg.lendigroup.com.au';
            case Environment.Preproduction:
                return !lendiGroupTeamView
                    ? 'https://team.aussie-preprod.com.au'
                    : 'https://aussie-team-preprod.lendigroup.com.au';
            case Environment.Production:
                return !lendiGroupTeamView ? 'https://team.aussie.com.au' : 'https://aussie-team.lendigroup.com.au';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.lendi-dev.net';
            case Environment.Staging:
                return 'https://www.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://www.lendi-preprod.net';
            case Environment.Production:
                return 'https://www.lendi.com.au';
        }
    }
    if (brand === Brand.Domain && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://dlf.lendi-paas-dev.net';
            case Environment.Staging:
                return 'https://stage.domain.com.au/loanfinder';
            case Environment.Preproduction:
                return 'https://stage.domain.com.au/loanfinder';
            case Environment.Production:
                return 'https://www.domain.com.au/loanfinder';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.aussie-dev.com.au';
            case Environment.Staging:
                return 'https://www.aussie-stg.com.au';
            case Environment.Preproduction:
                return 'https://www.aussie-preprod.com.au';
            case Environment.Production:
                return 'https://www.aussie.com.au';
        }
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
function getDomainUnauthUrl(environment) {
    switch (environment) {
        case Environment.Development:
            return 'https://dlf.lendi-paas-dev.net/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        case Environment.Staging:
        case Environment.Preproduction:
            return 'https://stage.domain.com.au/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        case Environment.Production:
            return 'https://www.domain.com.au/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        default:
            throw new Error("Unable to determine URLs for Domain in ".concat(environment));
    }
}
function getDomainAuthUrl(environment) {
    switch (environment) {
        case Environment.Development:
            return 'https://dlf.lendi-paas-dev.net/authentications/login';
        case Environment.Staging:
        case Environment.Preproduction:
            return 'https://stage.domain.com.au/authentications/login';
        case Environment.Production:
            return 'https://www.domain.com.au/authentications/login';
        default:
            throw new Error("Unable to determine URLs for Domain in ".concat(environment));
    }
}
export function getURLs(brand, type, environment, lendiGroupTeamView) {
    if (lendiGroupTeamView === void 0) { lendiGroupTeamView = false; }
    var baseURL = getBaseURL(brand, type, environment, lendiGroupTeamView);
    var unauthBaseURL = brand === Brand.Domain ? getDomainUnauthUrl(environment) : baseURL;
    var authBaseURL = brand === Brand.Domain ? getDomainAuthUrl(environment) : baseURL;
    if (type === Type.Team) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: '',
            authenticated: brand === Brand.Domain ? "".concat(baseURL, "/loanfinder/dashboard/applications") : "".concat(baseURL, "/dashboard/applications"),
            unauthenticated: "".concat(baseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    if (type === Type.Customer) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: brand === Brand.Domain ? "".concat(baseURL, "/sign-in/") : "".concat(baseURL, "/sign-in/sign-up/"),
            authenticated: "".concat(authBaseURL),
            unauthenticated: "".concat(unauthBaseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
//# sourceMappingURL=getURLs.js.map